import { isKrOrderEditable, type KrOrderShipping, type KrPaymentOrder } from '@entities/kr-payment/model'
import { useRegisterDeliveryInformationFormState } from '@features/delivery'
import { useEffect, useRef } from 'react'

export function useKrOrderShipping({
  enabled,
  orderId,
  shipping,
  status,
  canReplace,
}: {
  enabled: boolean
  orderId?: string
  shipping?: KrOrderShipping | null
  status?: KrPaymentOrder['status']
  canReplace?: boolean
}): KrOrderShipping | undefined {
  const { formState, handleChange } = useRegisterDeliveryInformationFormState()
  const restoredOrder = useRef<string | null>(null)
  useEffect(() => {
    if (!enabled || !orderId || !shipping || restoredOrder.current === orderId) {
      return
    }
    restoredOrder.current = orderId
    handleChange('name', shipping.orderName)
    handleChange('phone', shipping.orderPhone)
    handleChange('zipCode', shipping.orderZipCode)
    handleChange('address', shipping.address ?? shipping.orderAddress)
    handleChange('detailAddress', shipping.detailAddress ?? '')
  }, [enabled, orderId, shipping, handleChange])
  if (!enabled) {
    return undefined
  }
  if (status && !isKrOrderEditable({ status, canReplace })) {
    return shipping ?? undefined
  }
  return {
    orderName: formState.values.name.trim(),
    orderPhone: formState.values.phone.trim(),
    orderAddress: `${formState.values.address.trim()} ${formState.values.detailAddress.trim()}`.trim(),
    orderZipCode: formState.values.zipCode.trim(),
    address: formState.values.address.trim(),
    detailAddress: formState.values.detailAddress.trim(),
  }
}
